export default __webpack_public_path__ + "static/media/leaves-icon.14e6e980.svg";